import api from '../api';
import querystring from 'querystring';

class DataServiceCertificate {
  addCertificate(id_company, data) {
    return api.post(`certificates/${id_company}`, data);
  }

  getCertificate(id_company) {
    return api.get(`certificates/${id_company}`);
  }

  getCourseCertificate(id) {
    return api.get(`/certificates/course/${id}`);
  }

  addCourseCertificate(id, data) {
    return api.post(`/certificates/course/${id}`, data);
  }

  updateCourseCertificate(id, data) {
    return api.put(`/certificates/course/${id}`, data);
  }

  updateCertificate(id_company, data) {
    return api.put(`certificates/${id_company}`, data);
  }

  deleteCertificate(id) {
    return api.delete(`certificates/${id}`);
  }

  getCertificateCourse(id) {
    return api.get(`certificates/course-certificate/${id}`);
  }

  getCertificateCourseAndUser(id, id_user) {
    return api.get(`certificates/course-certificate/${id}/${id_user}`);
  }

  getPublicUserData(id_user) {
    return api.get(`/certificates/course-certificate/user/${id_user}`);
  }

  getPublicValidateUserData(id_company_course, id_enrollment) {
    return api.get(`/validate/course-certificate/user/${id_company_course}/${id_enrollment}`);
  }

  getPublicValidateUserDataCode(code) {
    return api.get(`/validate/course-certificate/code/${code}`);
  }
  
  download(id, data) {
    return api.post(`/certificates/pdf/${id}`, data);
  }

  downloadOffline(id, data) {
    return api.post(`/certificates-attendance/pdf/${id}`, data);
  }

  getStudentFinishedTrails(id_user) {
    return api.get(`certificates/student-finished-trails/${id_user}`);
  }

  downloadTrail(id_trail, data) {
    return api.post(`/certificates/trail-pdf/${id_trail}`, data);
  }
}

export default new DataServiceCertificate();
